import { render } from "./IframeComponent.vue?vue&type=template&id=4506f5c8"
import script from "./IframeComponent.vue?vue&type=script&lang=js"
export * from "./IframeComponent.vue?vue&type=script&lang=js"

import "./IframeComponent.vue?vue&type=style&index=0&id=4506f5c8&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__